import { useRef } from 'react';
import { connect } from 'react-redux';

import MelodyModal from 'components/common/MelodyModal';
import useMartyContext from 'hooks/useMartyContext';
import { createHeartList } from 'actions/hearts';

import css from 'styles/components/account/collectionModals/newCollectionModal.scss';

export const NewCollectionModal = ({
  onDoneModal,
  showNewCollectionModal,
  onCancelModal,
  createHeartList
}) => {
  const input = useRef();

  const onSaveNewCollection = e => {
    e.preventDefault();
    const { collectionName: { value } } = e.currentTarget;
    createHeartList({ listName: value }).then(onDoneModal);
  };

  const onAfterOpen = () => {
    input.current?.focus();
  };

  const { testId } = useMartyContext();

  return (
    <MelodyModal
      className={css.modal}
      contentLabel="Create a New Collection"
      heading="Create New Collection"
      headingTestId="newCollectionModalHeader"
      isOpen={showNewCollectionModal}
      onAfterOpen={onAfterOpen}
      onRequestClose={onCancelModal}
    >
      <div>
        <form method="post" onSubmit={onSaveNewCollection}>
          <div className={css.fields}>
            <label htmlFor="collectionName">Collection Name</label>
            <input
              ref={input}
              name="collectionName"
              id="collectionName"
              type="text"
              data-test-id={testId('newCollectionNameInputBox')}/>
          </div>

          <div className={css.footer}>
            <button type="button" onClick={onCancelModal} data-test-id={testId('cancelButton')}>Cancel</button>
            <button type="submit" data-test-id={testId('createButton')}>Create</button>
          </div>
        </form>
      </div>
    </MelodyModal>
  );
};

export const mapStateToProps = () => ({});
const ConnectedNewCollectionModal = connect(mapStateToProps, {
  createHeartList
})(NewCollectionModal);

export default ConnectedNewCollectionModal;
